// Wrapper for prettyPhoto that avoids ES module strict mode.
// prettyPhoto uses many implicit globals (hashtag, doresize, theRel, etc.)
// which are ReferenceErrors in strict mode. The Function() constructor
// creates a non-strict scope.
import prettyPhotoCode from './jquery.prettyPhoto.raw.js?raw'
import jQuery from 'jquery'
new Function('jQuery', '$', prettyPhotoCode)(jQuery, jQuery)
